import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { childNames, propsChild, typeState } from './types';

import childBlueAnim from '../../assets/images/game/children/blue_anim_2.gif';
import childBlueFallAnim from '../../assets/images/game/children/blue_anim_1.gif';
import childBlueImg from '../../assets/images/game/children/blue_1.svg';
import childBlueAnchor from '../../assets/images/game/children/blue_anchor.png';

import childOrangeImg from '../../assets/images/game/children/orange_1.svg';
import childOrangeAnim from '../../assets/images/game/children/orange_anim_2.gif';
import childOrangeFallAnim from '../../assets/images/game/children/orange_anim_1.gif';
import childOrangeAnchor from '../../assets/images/game/children/orange_anchor.png';

import childPurpleAnim from '../../assets/images/game/children/purple_anim_2.gif';
import childPurpleFallAnim from '../../assets/images/game/children/purple_anim_1.gif';
import childPurpleImg from '../../assets/images/game/children/purple_1.svg';
import childPurpleAnchor from '../../assets/images/game/children/purple_anchor.png';

import childPinkAnim from '../../assets/images/game/children/pink_anim_2.gif';
import childPinkFallAnim from '../../assets/images/game/children/pink_anim_1.gif';
import childPinkImg from '../../assets/images/game/children/pink_1.svg';
import childPinkAnchor from '../../assets/images/game/children/pink_anchor.png';

import childGreyAnim from '../../assets/images/game/children/grey_anim_2.gif';
import childGreyFallAnim from '../../assets/images/game/children/grey_anim_1.gif';
import childGreyImg from '../../assets/images/game/children/grey_1.svg';
import childGreyAnchor from '../../assets/images/game/children/grey_anchor.png';

import childYellowAnim from '../../assets/images/game/children/yellow_anim_2.gif';
import childYellowFallAnim from '../../assets/images/game/children/yellow_anim_1.gif';
import childYellowImg from '../../assets/images/game/children/yellow_1.svg';
import childYellowAnchor from '../../assets/images/game/children/yellow_anchor.png';

const initialState: typeState = {
  children: [
    {
      name: childNames.BLUE,
      start: false,
      stop: false,
      fall: false,
      reachedTargets: false,
      isDied: false,
      img: childBlueImg,
      anchorImg: childBlueAnchor,
      anim: {
        up: childBlueAnim,
        down: childBlueFallAnim,
      },
    },
    {
      name: childNames.ORANGE,
      start: false,
      stop: false,
      fall: false,
      reachedTargets: false,
      isDied: false,
      img: childOrangeImg,
      anchorImg: childOrangeAnchor,
      anim: {
        up: childOrangeAnim,
        down: childOrangeFallAnim,
      },
    },
    {
      name: childNames.PURPLE,
      start: false,
      stop: false,
      fall: false,
      reachedTargets: false,
      isDied: false,
      img: childPurpleImg,
      anchorImg: childPurpleAnchor,
      anim: {
        up: childPurpleAnim,
        down: childPurpleFallAnim,
      },
    },
    {
      name: childNames.PINK,
      start: false,
      stop: false,
      fall: false,
      reachedTargets: false,
      isDied: false,
      img: childPinkImg,
      anchorImg: childPinkAnchor,
      anim: {
        up: childPinkAnim,
        down: childPinkFallAnim,
      },
    },
    {
      name: childNames.GREY,
      start: false,
      stop: false,
      fall: false,
      reachedTargets: false,
      isDied: false,
      img: childGreyImg,
      anchorImg: childGreyAnchor,
      anim: {
        up: childGreyAnim,
        down: childGreyFallAnim,
      },
    },
    {
      name: childNames.YELLOW,
      start: false,
      stop: false,
      fall: false,
      reachedTargets: false,
      isDied: false,
      img: childYellowImg,
      anchorImg: childYellowAnchor,
      anim: {
        up: childYellowAnim,
        down: childYellowFallAnim,
      },
    },
  ],
};

export const children = createSlice({
  name: 'children',
  initialState,
  reducers: {
    setStart(state, action: PayloadAction<childNames>) {
      state.children.map((item, idx) => {
        if (item.name === action.payload) {
          state.children[idx].start = true;
        }
      });
    },
    setStop(state, action: PayloadAction<childNames>) {
      state.children.map((item, idx) => {
        if (item.name === action.payload) {
          state.children[idx].stop = true;
        }
      });
    },
    setFall(state, action: PayloadAction<childNames>) {
      state.children.map((item, idx) => {
        if (item.name === action.payload) {
          state.children[idx].fall = true;
        }
      });
    },
    setPlay(state, action: PayloadAction<childNames>) {
      state.children.map((item, idx) => {
        if (item.name === action.payload) {
          state.children[idx].stop = false;
          state.children[idx].fall = false;
        }
      });
    },

    setReachedTargets(state, action: PayloadAction<childNames>) {
      state.children.map((item, idx) => {
        if (item.name === action.payload) {
          state.children[idx].reachedTargets = true;
        }
      });
    },

    setIsDied(state, action: PayloadAction<childNames>) {
      state.children.map((item, idx) => {
        if (item.name === action.payload) {
          state.children[idx].isDied = true;
        }
      });
    },
    nextLevel(state) {
      state.children.map((el, idx) => {
        state.children[idx].reachedTargets = false;
      });
    },
    updateChildren(state) {
      state.children.map((el, idx) => {
        state.children[idx].isDied = false;
      });
    },
  },
});

export const {
  setStart,
  setFall,
  setPlay,
  setStop,
  setReachedTargets,
  setIsDied,
  nextLevel,
  updateChildren,
} = children.actions;

export default children.reducer;
